import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";

export const BrandMarquee = () => (
  <div data-testid="marquee" className="border-y border-[#ddd6c8] bg-[#eae4d8] py-6">
    <Marquee speed={40} gradient={false} autoFill>
      {MARQUEE_ITEMS.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="px-8 font-serif text-3xl italic text-[#23281f] md:text-4xl">{item}</span>
          <span className="text-2xl text-[#ba5a45]">✦</span>
        </div>
      ))}
    </Marquee>
  </div>
);
